import {
  booleanAttribute,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  input,
  model,
} from '@angular/core';

import type { CustomSelectOption } from '../../types/custom-select-option';

import { DisplayLabel } from './display-label';
import { DisplayOptions } from './display-options';

@Component({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-select',
  styleUrl: './select.css',
  templateUrl: './select.html',
})
export class Select {
  public readonly allItemsLabel = input<string>('');
  public readonly label = input<string>('');
  public readonly multiSelect = input(false, { transform: booleanAttribute });
  public readonly options = input<CustomSelectOption[]>([]);

  public readonly value = model.required<string | string[]>();

  protected readonly displayOptions = computed(() => DisplayOptions.call(this));
  protected readonly displayValue = computed(() => DisplayLabel.call(this));

  private _multipleSelect(event: PointerEvent, value: string): void {
    // Prevent the menu from closing when clicking on an option.
    if (value !== '-all-items-') {
      event.stopImmediatePropagation();
    }

    // Add or remove the value from the selected values.
    if (value === '-all-items-') {
      this.value.set([]);
    } else if (!this.value().includes(value)) {
      // eslint-disable-next-line @typescript-eslint/no-misused-spread -- We want to spread the existing values into a new array and add the new value.
      this.value.update((v) => [...v, value]);
    } else {
      this.value.update((v) => (v as string[]).filter((x) => x !== value));
    }
  }

  private _singleSelect(value: string): void {
    if (value === '-all-items-') {
      this.value.set('');
    } else {
      this.value.set(this.multiSelect() ? [value] : value);
    }
  }

  protected select(event: PointerEvent, value: string, disabled?: boolean): void {
    if (disabled) {
      return;
    }

    // Select or deselect the value based on whether it's a multi-select or single-select.
    if (this.multiSelect()) {
      this._multipleSelect(event, value);
    } else {
      this._singleSelect(value);
    }
  }
}
